export const FETCH_INBOXREQUEST_ACTION = "FETCH_INBOXREQUEST_ACTION";
export const FETCH_INBOXREQUEST_FAIL_ACTION =
  FETCH_INBOXREQUEST_ACTION + "_ERROR";
export const FETCH_INBOXREQUEST_SUCCESS_ACTION =
  FETCH_INBOXREQUEST_ACTION + "_SUCCESS";

export const FETCH_OUTBOXREQUEST_ACTION = "FETCH_OUTBOXREQUEST_ACTION";
export const FETCH_OUTBOXREQUEST_FAIL_ACTION =
  FETCH_OUTBOXREQUEST_ACTION + "_ERROR";
export const FETCH_OUTBOXREQUEST_SUCCESS_ACTION =
  FETCH_OUTBOXREQUEST_ACTION + "_SUCCESS";

export const DELETE_INBOX_INIT_ACTION = "DELETE_INBOX_INIT_ACTION";
export const DELETE_INBOX_SUCCESS_ACTION =
  DELETE_INBOX_INIT_ACTION + "_SUCCESS";
export const DELETE_INBOX_FAIL_ACTION = DELETE_INBOX_INIT_ACTION + "_ERROR";

export const DELETE_OUTBOX_INIT_ACTION = "DELETE_OUTBOX_INIT_ACTION";
export const DELETE_OUTBOX_SUCCESS_ACTION =
  DELETE_OUTBOX_INIT_ACTION + "_SUCCESS";
export const DELETE_OUTBOX_FAIL_ACTION = DELETE_OUTBOX_INIT_ACTION + "_ERROR";

export const FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION =
  "FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION";
export const FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_FAIL_ACTION =
  FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION + "_ERROR";
export const FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_SUCCESS_ACTION =
  FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION + "_SUCCESS";

export function fetchinboxrequest(params) {
  return {
    type: FETCH_INBOXREQUEST_ACTION,
    params: params,
  };
}

export function fetchoutboxrequest(params) {
  return {
    type: FETCH_OUTBOXREQUEST_ACTION,
    params: params,
  };
}
export function deleteinboxItem(value) {
  return {
    type: DELETE_INBOX_INIT_ACTION,
    value: value,
  };
}
export function deleteoutboxItem(value) {
  return {
    type: DELETE_OUTBOX_INIT_ACTION,
    value: value,
  };
}

export function fetchRequestTypeInPartnerRequest() {
  return {
    type: FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION,
  };
}
